//To handle more microservice

export const getbaseUrl = (url) => {
  switch (url) {
    case "users":
      return process.env.REACT_APP_API_URL;
    case "schemes":
      return process.env.REACT_APP_SCHEMES_API_URL;
    case "notifications":
      return process.env.REACT_APP_NOTIFICATIONS_API_URL;
    case "orders":
      return process.env.REACT_APP_ORDERS_API_URL;
    case "payments":
      return process.env.REACT_APP_PAYMENTS_API_URL;
    case "magento":
      return process.env.REACT_APP_MAGENTO_API_URL;
    case "grafana":
      return process.env.REACT_APP_GRAFANA_API_URL;
    case "reports":
      return process.env.REACT_APP_REPORT_URL;
    case "referearn":
      return process.env.REACT_APP_REFERANDEARN_URL;
    case "crm":
      return process.env.REACT_APP_CRM_URL;
    default:
      return process.env.REACT_APP_API_URL;
  }
};
